import BaseStore from '../../../../components/BaseStore'

export default {
  extends: BaseStore,
  props: {
    model: {
      required: true,
      type: Object
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/BaseHySplit.js